module.exports = {"id":"186684","name":"Kiko Olivas","rating":"73","photo":"./data/images/photos/3/186684.png","club":{"name":"Real Valladolid","logo":"./data/images/clubs/RealValladolid.png"},"positions":["DC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/KikoOlivas0.json
// module id = 2375
// module chunks = 0